import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Center,
  FormControl,
  FormLabel,
  Input,
  Button,
  FormErrorMessage,
  Grid,
} from "@chakra-ui/react";
import styles from "./styles.module.scss";
import logo from "../../assets/logo-interbrasil-login.webp";
import { useAuth } from "../../hooks/useAuth";

const Login = () => {
  const { signIn, loadingLogin } = useAuth();
  const storageToken = localStorage.getItem("@portalinterbrasil:token");

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Preencha o e-mail"),
      password: Yup.string().required("Preencha a senha"),
    }),
    onSubmit: (values, actions) => {
      actions.setSubmitting(true);
      const data = {
        username: values.username,
        password: values.password,
      };
      if (data.username) {
        signIn(data);
        actions.setSubmitting(false);
      }
      actions.setSubmitting(false);
    },
  });

  if (storageToken) {
    return null;
  }

  return (
    <div className={styles.login}>
      <img src={logo} alt="InterBrasil Saúde" />
      <Center
        maxWidth="400px"
        width="100%"
        bg="white"
        borderRadius="20px"
        boxShadow="0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
        padding="30px"
        display="flex"
        flexDirection="column"
        gridGap="20px"
      >
        <form
          onReset={formik.handleReset}
          onSubmit={formik.handleSubmit}
          style={{ width: "100%" }}
        >
          <Grid gap={6}>
            <FormControl
              id="username"
              isInvalid={
                formik.values.username.length < 1 && formik.touched.username
              }
            >
              <FormLabel htmlFor="username">
                E-mail <span style={{ color: "#E53E3E" }}>*</span>
              </FormLabel>
              <Input
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.username}
                id="username"
                name="username"
              />
              {formik.touched.username && formik.errors.username ? (
                <FormErrorMessage>{formik.errors.username}</FormErrorMessage>
              ) : null}
            </FormControl>
            <FormControl
              id="password"
              isInvalid={
                formik.values.password.length < 1 && formik.touched.password
              }
            >
              <FormLabel htmlFor="password">
                Senha <span style={{ color: "#E53E3E" }}>*</span>
              </FormLabel>
              <Input
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
                id="password"
                name="password"
                type="password"
                autoComplete="true"
              />
              {formik.touched.password && formik.errors.password ? (
                <FormErrorMessage>{formik.errors.password}</FormErrorMessage>
              ) : null}
            </FormControl>
            <Button
              isLoading={loadingLogin}
              type="submit"
              w="100%"
              colorScheme="blue"
            >
              Entrar
            </Button>
          </Grid>
        </form>
      </Center>
    </div>
  );
};

export default Login;
